import $ from "cash-dom";

export default {
  install(Vue) {
    let offset = 0;
    const onScrollHeader = function($el) {
      if (window.pageYOffset - offset - $el.height() > 0) {
        $el.css("top", "0px");
      } else {
        $el.css("top", -$el.height() + (window.pageYOffset - offset) + "px");
      }
    };

    Vue.directive("scrollable-header", {
      beforeMount(el, binding) {
        offset = binding.value.offset;
      },

      mounted(el) {
        const $el = $(el);
        $el.css("top", "-" + $el.height() + "px");

        $(window)
          .on("scroll", function() {
            if ($(window).width() > 992) {
              onScrollHeader($el);
            }
          })
          .trigger("scroll");
      },

      updated() {}
    });

    Vue.directive("scrollable-header-offseter", {
      beforeMount() {},

      mounted(el) {
        const $el = $(el);
        offset = $el.height();
      },

      updated() {}
    });
  }
};
